import React from 'react'
import { Grid, Typography, Box} from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

function OpenLmisImpact() {
  return (
    <div>
      <Box sx={{ backgroundColor: "#f5f5f5"}}>
      <Grid container spacing={4} alignItems="center">
        
        {/* Left Side: Circular Image */}
        <Grid size={{ xs: 12, sm:4 , md: 4  , lg:4}}>
          <Box>
            <img
              className='desktopLmisimage'
              src={imgUrl.afghanistanKid} 
              alt="Afghanistan kid"
              style={{ width: "100%", height: "auto", objectFit: "cover", display: "block" }}
            />
            <img
              className='tabletOpenlmisimage'
              src={imgUrl.afghanistanKidcircular} 
              alt="Afghanistan kid"
              style={{ width: "100%", height: "auto", objectFit: "cover", marginLeft:"20px"}}
            />
          </Box>
        </Grid>

        {/* Right Side: Text */}
        <Grid size={{ xs: 12, sm:8, md: 8 , lg:8}}>
         
          <Box padding={4}>
                 <Typography
            variant="h6"
            sx={{ color: "#6e1b9b ", fontWeight: "bold", mb: 2 }}
          >
            ENHANCING AFGHANISTAN'S HEALTH SUPPLY CHAIN WITH OPENLMIS
          </Typography>

          <Typography variant="body1" paragraph>
            Dure Technologies supported UNDP Afghanistan in implementing
            OpenLMIS to strengthen the national health supply chain. The system
            improved visibility of essential commodities, streamlined stock
            management, and enhanced reporting for timely decision-making.
        </Typography>

          </Box>
        </Grid>
      </Grid>
    </Box>

    <Box sx={{backgroundColor : '#fff'}}>
      <Grid container spacing={4} alignItems="center">
        
        {/* Left Side: Circular Image */}
         <Grid size={{ xs: 12, sm:8, md: 8 , lg:8}}>
         
          <Box padding={4}>
                 <Typography
            variant="h6"
            sx={{ color: "#6e1b9b ", fontWeight: "bold", mb: 2 }}
          >
            OPEN LMIS IN THE CENTRAL AFRICAN REBUBLIC
          </Typography>

          <Typography variant="body1" paragraph>
              In the Central African Republic, Dure deployed an OpenLMIS-powered
              dashboard that brings real-time visibility to the national health supply chain.
              Tracking over 400 facilities and 150 products, the platform helps identify stock-
              outs, monitor requisition flows, and guide rapid action across programs like HIV,
              TB, and malaria. Seamlessly integrated with DHIS2 and national systems, it
              transforms complex logistics data into clear, actionable insights.
          </Typography>

          </Box>
        </Grid>
       
        {/* Right Side: Text */}
         <Grid size={{ xs: 12, sm:4, md: 4 , lg:4}}>
          <Box>
            <img
              className='desktopLmisimage'
              src={imgUrl.carBg} 
              alt="Car Health Check up"
              style={{ width: "100%", height: "auto", objectFit: "cover", display: "block" }}
            />
             <img
             className='tabletOpenlmisimage'
              src={imgUrl.carCircular} 
              alt="Car Health Check up"
              style={{ width: "100%", height: "auto", objectFit: "cover",  marginLeft:"-20px"}}
            />
          </Box>
        </Grid>

      </Grid>
    </Box>
    </div>
  )
}

export default OpenLmisImpact
